import React, { Component } from "react";
import { Input } from "reactstrap";
import axios from "axios";
import SelectMultiColumn from "../../Components/SelectMultiColumn/SelectMultiColumn";
import { serverUrl } from "../../../config.js";
import { activeLanguage } from "../../../config";
import { getLanguage } from "../../../languages";
import { ArrowBackIos, Cancel, Save, Close } from "@mui/icons-material";
import ButtonUI from "@mui/material/Button";
import {
  Typography,
  Box,
  Grid,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  DialogTitle,
  IconButton,
  Slide,
  Divider,
  FormControlLabel,
  Checkbox,
  Snackbar,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import Select from "react-select";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class EditAdmin extends Component {
  constructor(props) {
    super(props);
    this.globallang = getLanguage(activeLanguage, "global");
    this.language = getLanguage(activeLanguage, "editadmin");
    this.state = {
      phoneno: props.match.params.phoneno,
      name: "",
      logintype: "",
      profilepic: [],
      email: "",
      issuspend: 0,
      dataShow: [],
      communityList: [],
      MerchantShow: [],
      suspendShow: [
        { issuspendId: 0, issuspendName: "No" },
        { issuspendId: 1, issuspendName: "Yes" },
      ],
      typeLoginOption: [],
      typeLoginSelected: null,
      dataAgent: [],
      agentSelected: null,
      accountSelected: null,
      accountOption: [],
      openValidation: false,
      titleValidation: "",
      titleBody: "",
      accountAllOption: [],
      fullAccess: false,
      addAccount: false,
      addBatch: false,
      setSL: false,
      changeLot: false,
      suspend: false,
      setTP: false,
      pause: false,
      standby: false,
      sw: false,
      active: false,
      openError: false,
      openSnackbar: false,
      errorMessage: "",
      snackbarMessage: "",
      snackbarSeverity: "success",
      pair_type_option: [],
      pair_type_selected: [],
    };
  }

  handleChangePairType = (pair_type_selected) => {
    this.setState({ pair_type_selected });
  };

  handleChangeAccessRights = (event) => {
    const { name, checked } = event.target;

    if (name === "fullAccess") {
      if (!checked) {
        this.setState({
          fullAccess: checked,
          addAccount: false,
          addBatch: false,
          setSL: false,
          setTP: false,
          pause: false,
          changeLot: false,
          suspend: false,
          active: false,
          standby: false,
          sw: false,
        });
      } else {
        this.setState({
          fullAccess: checked,
          addAccount: true,
          addBatch: true,
          setSL: true,
          setTP: true,
          pause: true,
          changeLot: true,
          suspend: true,
          active: true,
          standby: true,
          sw: true,
        });
      }
    } else {
      this.setState({ [name]: checked }, () => {
        if (
          this.state.changeLot &&
          this.state.suspend &&
          this.state.active &&
          this.state.addAccount &&
          this.state.addBatch &&
          this.state.setSL &&
          this.state.setTP &&
          this.state.pause &&
          this.state.standby &&
          this.state.sw
        ) {
          this.setState({
            fullAccess: true,
          });
        } else {
          this.setState({
            fullAccess: false,
          });
        }
      });
    }
  };

  selectRole = (dataShow) => {
    axios
      .post(
        serverUrl + "cp_get_logincptype_list.php",
        {},
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        }
      )
      .then((response) => {
        const data = response.data;
        if (data.status === "ok") {
          if (data.records.length > 0) {
            this.setState({
              typeLoginOption: data.records,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
        alert(error);
      });
  };

  doApiAgent = () => {
    axios
      .post(
        serverUrl + "agent_list_data.php",
        {},
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        }
      )
      .then((response) => {
        const data = response.data;
        if (data.status === "OK") {
          if (data.records.length > 0) {
            const newArray = data.records.map((item) => ({
              label: item.agent_name,
              value: item.agent_id,
              infoAccount: item.infoAccount,
              shared_profit: item.shared_profit,
            }));

            this.setState({
              dataAgent: newArray,
            });
          }
        }

        this.doGetData();
      })
      .catch((error) => {
        console.log(error);
        alert(error);
      });
  };

  doApiAccountMasterPairType = () => {
    axios
      .post(
        serverUrl + "account_master_pair_type_option.php",
        {},
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        }
      )
      .then((response) => {
        const data = response.data;
        if (data.status === "OK") {
          if (data.records.length > 0) {
            this.setState({
              pair_type_option: data.records,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
        alert(error);
      });
  };

  doApiAccount = () => {
    // this.props.doLoading();
    axios
      .post(
        serverUrl + "account_option.php",
        {},
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        }
      )
      .then((response) => {
        this.doApiAgent();

        // this.props.doLoading();
        const data = response.data;
        if (data.status === "OK") {
          if (data.records.length > 0) {
            this.setState({
              accountOption: data.records,
              accountAllOption: data.records,
            });
          }
        }
      })
      .catch((error) => {
        // this.props.doLoading();
        console.log(error);
        alert(error);
      });
  };

  doNewApiAccount = () => {
    // this.props.doLoading();
    axios
      .post(
        serverUrl + "account_option.php",
        {},
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        }
      )
      .then((response) => {
        // this.props.doLoading();
        const data = response.data;
        if (data.status === "OK") {
          if (data.records.length > 0) {
            this.setState({
              accountOption: data.records,
              accountAllOption: data.records,
            });
          }
        }
      })
      .catch((error) => {
        // this.props.doLoading();
        console.log(error);
        alert(error);
      });
  };

  suspendHandleChange = (issuspend) => {
    this.setState({
      issuspend: issuspend,
    });
  };

  checkData = () => {
    const {
      phoneno,
      name,
      typeLoginSelected,
      agentSelected,
      // accountSelected,
      email,
      password,
      confirmpass,
    } = this.state;

    if (phoneno === "") {
      this.setState({
        openValidation: true,
        titleValidation: "Empty phone number?",
        titleBody: "Enter phone number",
      });
    } else if (name === "") {
      this.setState({
        openValidation: true,
        titleValidation: "Empty name?",
        titleBody: "Enter name",
      });
    } else if (typeLoginSelected === null) {
      this.setState({
        openValidation: true,
        titleValidation: "Empty type?",
        titleBody: "Select type",
      });
    } else if (
      typeLoginSelected !== null &&
      typeLoginSelected.value === 2 &&
      agentSelected === null
    ) {
      this.setState({
        openValidation: true,
        titleValidation: "Empty agent?",
        titleBody: "Select agent",
      });
    }
    // else if (
    //   typeLoginSelected !== null &&
    //   typeLoginSelected.value === 3 &&
    //   agentSelected !== null &&
    //   accountSelected === null
    // ) {
    //   this.setState({
    //     openValidation: true,
    //     titleValidation: "Empty account number?",
    //     titleBody: "Select account number",
    //   });
    // } else if (
    //   typeLoginSelected !== null &&
    //   typeLoginSelected.value === 4 &&
    //   agentSelected === null &&
    //   accountSelected === null
    // ) {
    //   this.setState({
    //     openValidation: true,
    //     titleValidation: "Empty account number?",
    //     titleBody: "Select account number",
    //   });
    // }
    else if (email === "") {
      this.setState({
        openValidation: true,
        titleValidation: "Empty email?",
        titleBody: "Enter email",
      });
    } else if (password === "") {
      this.setState({
        openValidation: true,
        titleValidation: "Empty password?",
        titleBody: "Enter password",
      });
    } else if (confirmpass === "") {
      this.setState({
        openValidation: true,
        titleValidation: "Empty confirm password?",
        titleBody: "Enter confirm password",
      });
    } else if (password !== confirmpass) {
      this.setState({
        openValidation: true,
        titleValidation: "Warning!",
        titleBody: "Password and confirm password do not match.",
      });
    } else {
      this.onSubmit();
    }
  };

  componentDidMount = (dataShow) => {
    this.selectRole(dataShow);

    this.doApiAccount();
    this.doApiAccountMasterPairType();
    this.props.doLoading();
  };

  doGetData = () => {
    axios
      .post(
        serverUrl + "admin_by_phoneno_v2.php",
        {
          phoneno: this.state.phoneno,
        },

        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        }
      )
      .then((response, logintype) => {
        this.props.doLoading();

        const data = response.data;
        if (data.status === "ok") {
          const record = data.record;

          let tmp = [];
          if (record.profilepic !== "") {
            tmp.push(record.profilepic);
          }

          if (record.logintype === 1) {
            const filterType = this.state.typeLoginOption.filter(
              (obj) => obj.value === record.logintype
            );

            this.setState({ phoneno: record.phoneno });
            this.setState({ name: record.name });
            this.setState({
              typeLoginSelected: filterType[0],
            });

            this.setState({ profilepic: tmp });
            this.setState({ email: record.email });
            this.setState({ issuspend: record.suspend });
          } else if (record.logintype === 2 || record.logintype === 3) {
            const filterType = this.state.typeLoginOption.filter(
              (obj) => obj.value === record.logintype
            );

            //console.log("filterType: ", filterType);

            const agentId = record.agent === "" ? "" : record.agent.id;

            const filterAgent = this.state.dataAgent.filter(
              (obj) => obj.value === agentId
            );

            //console.log("filterAgent: ", filterAgent);

            const acctInfo = filterAgent.length > 0 ? filterAgent[0] : [];

            //console.log("acctInfo: ", acctInfo);

            const newAccountOption = acctInfo.infoAccount.map((obj) => ({
              value: obj.account_number,
              label: `${obj.account_number}(${obj.alias})`,
            }));

            //console.log("newAccountOption: ", newAccountOption);

            this.setState({
              accountOption: newAccountOption,
            });

            const dataInfoAccount = record.infoAccount;

            //console.log("dataInfoAccount: ", dataInfoAccount);

            const filteredAccounts = acctInfo.infoAccount.filter((account) => {
              return dataInfoAccount.some(
                (info) => info.account.toString() === account.account_number
              );
            });

            //console.log("filteredAccounts: ", filteredAccounts);

            const newAccount = filteredAccounts.map((obj) => ({
              value: obj.account_number,
              label: `${obj.account_number}(${obj.alias})`,
            }));

            //console.log("newAccount: ", newAccount);

            this.setState({ phoneno: record.phoneno });
            this.setState({ name: record.name });
            this.setState({
              typeLoginSelected: filterType[0],
            });
            this.setState({
              agentSelected: filterAgent.length > 0 ? filterAgent[0] : null,
            });

            this.setState({
              accountSelected: newAccount.length > 0 ? newAccount : null,
            });
            this.setState({ profilepic: tmp });
            this.setState({ email: record.email });
            this.setState({
              issuspend: record.suspend,
            });

            if (record.access_rights !== "") {
              this.setState({
                fullAccess: record.access_rights.full_access,
                addAccount: record.access_rights.can_open,
                addBatch: record.access_rights.can_shoot,
                setSL: record.access_rights.can_set_sl,
                changeLot: record.access_rights.can_change_lot,
                setTP: record.access_rights.can_set_tp,
                pause: record.access_rights.can_pause,
                active: record.access_rights.can_change_active,
                suspend: record.access_rights.can_change_suspend,
                standby: record.access_rights.can_stand_by,
                sw: record.access_rights.can_start_wait,
              });
            }

            const fromApiPairs = Array.isArray(record.pair_type_master_accounts)
              ? record.pair_type_master_accounts.map((o) => ({
                  value: o.value,
                  key: o.key,
                  label: o.label,
                }))
              : [];

            const optionByValue = new Map(
              (this.state.pair_type_option || []).map((o) => [
                String(o.value),
                o,
              ])
            );
            const missing = fromApiPairs.filter(
              (o) => !optionByValue.has(String(o.value))
            );
            const mergedOptions =
              missing.length > 0
                ? [...this.state.pair_type_option, ...missing]
                : this.state.pair_type_option;

            this.setState({
              pair_type_option: mergedOptions,
              pair_type_selected: fromApiPairs,
            });
          } else if (record.logintype === 4) {
            const filterType = this.state.typeLoginOption.filter(
              (obj) => obj.value === record.logintype
            );

            const dataInfoAccount = record.infoAccount;

            const filteredAccounts = this.state.accountOption.filter(
              (account) => {
                return dataInfoAccount.some(
                  (info) => info.account.toString() === account.value
                );
              }
            );

            // console.log("accountAllOption: ", this.state.accountAllOption);

            this.setState({ phoneno: record.phoneno });
            this.setState({ name: record.name });
            this.setState({
              typeLoginSelected: filterType[0],
            });
            this.setState({
              agentSelected: null,
            });

            this.setState({
              accountSelected:
                filteredAccounts.length > 0 ? filteredAccounts : null,
            });
            this.setState({ profilepic: tmp });
            this.setState({ email: record.email });
            this.setState({
              issuspend: record.suspend,
            });

            if (record.access_rights !== "") {
              this.setState({
                fullAccess: record.access_rights.full_access,
                addAccount: record.access_rights.can_open,
                addBatch: record.access_rights.can_shoot,
                setSL: record.access_rights.can_set_sl,
                changeLot: record.access_rights.can_change_lot,
                setTP: record.access_rights.can_set_tp,
                pause: record.access_rights.can_pause,
                active: record.access_rights.can_change_active,
                suspend: record.access_rights.can_change_suspend,
                standby: record.access_rights.can_stand_by,
                sw: record.access_rights.can_start_wait,
              });
            }

            const fromApiPairs = Array.isArray(record.pair_type_master_accounts)
              ? record.pair_type_master_accounts.map((o) => ({
                  value: o.value,
                  key: o.key,
                  label: o.label,
                }))
              : [];

            const optionByValue = new Map(
              (this.state.pair_type_option || []).map((o) => [
                String(o.value),
                o,
              ])
            );
            const missing = fromApiPairs.filter(
              (o) => !optionByValue.has(String(o.value))
            );
            const mergedOptions =
              missing.length > 0
                ? [...this.state.pair_type_option, ...missing]
                : this.state.pair_type_option;

            this.setState({
              pair_type_option: mergedOptions,
              pair_type_selected: fromApiPairs,
            });
          }
        }
      })
      .catch((error) => {
        this.props.doLoading();
      });
  };

  onSubmit = () => {
    let params = {
      phoneno: this.state.phoneno,
      name: this.state.name,
      logintype: this.state.typeLoginSelected.value,
      agent:
        this.state.agentSelected === null ? "" : this.state.agentSelected.value,
      account: this.state.accountSelected,
      email: this.state.email,
      password: this.state.password,
      suspend: this.state.issuspend,
      fullAccess: this.state.fullAccess,
      addAccount: this.state.addAccount,
      addBatch: this.state.addBatch,
      setSL: this.state.setSL,
      changeLot: this.state.changeLot,
      setTP: this.state.setTP,
      standby: this.state.standby,
      sw: this.state.sw,
      pause: this.state.pause,
      active: this.state.active,
      suspended: this.state.suspend,
      pair_type_master_accounts: (this.state.pair_type_selected || []).map(
        (o) => o.value
      ),
      pair_type: (this.state.pair_type_selected || []).map((o) => o.key),
    };
    // console.log(params);
    this.props.doLoading();
    axios
      .post(serverUrl + "admin_update_v3.php", params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
      })
      .then((response) => {
        this.props.doLoading();
        if (response.data.status === "ok") {
          this.showSnackbar(
            "The user record has been updated successfully.",
            "success"
          );
          setTimeout(() => {
            this.props.history.push("/panel/user");
          }, 4000);
        } else {
          const serverMsg =
            response.data.message || "Unable to update the user.";
          this.showSnackbar(`Update failed: ${serverMsg}`, "error");
        }
      })
      .catch((error) => {
        this.props.doLoading();
        const networkMsg =
          error.message || "A network error occurred. Please try again later.";
        this.showSnackbar(networkMsg, "error");
      });
  };

  showSnackbar = (message, severity) => {
    this.setState({
      snackbarMessage: message,
      snackbarSeverity: severity,
      openSnackbar: true,
    });
  };

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  renderAlert = () => {
    return (
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.openSnackbar}
        autoHideDuration={3000}
        onClose={this.handleCloseSnackbar}
        style={{ marginTop: "80px" }}
      >
        <MuiAlert
          variant="filled"
          onClose={this.handleCloseSnackbar}
          severity={this.state.snackbarSeverity}
        >
          {this.state.snackbarMessage}
        </MuiAlert>
      </Snackbar>
    );
  };

  handleChangeTypeLogin = (typeLoginSelected) => {
    if (typeLoginSelected.value === 4) {
      this.doNewApiAccount();
    }

    this.setState({
      typeLoginSelected,
      agentSelected: null,
      accountSelected: null,
    });
  };

  handleChangeAgent = (agentSelected) => {
    // console.log(agentSelected);

    const newAccount = agentSelected.infoAccount.map((obj) => ({
      value: obj.account_number,
      label: `${obj.account_number}(${obj.alias})`,
    }));

    // console.log(newAccount);

    this.setState({
      agentSelected,
      accountOption: newAccount,
      accountSelected: null,
    });
  };

  handleChangeAccount = (accountSelected) => {
    this.setState({
      accountSelected,
    });
  };

  handleCloseValidationAlert = () => {
    this.setState({
      openValidation: false,
      titleValidation: "",
      titleBody: "",
    });
  };

  renderValidationAlert = () => {
    return (
      <Dialog
        open={this.state.openValidation}
        onClose={this.handleCloseValidationAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        TransitionComponent={Transition}
        fullWidth={true}
        maxWidth="xs"
      >
        <DialogTitle id="alert-dialog-title">
          <div className="label-title-alert">{this.state.titleValidation}</div>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            <div className="title-body-alert"> {this.state.titleBody} </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <IconButton
            style={{ backgroundColor: "#f2f2f2" }}
            onClick={this.handleCloseValidationAlert}
          >
            <Close />
          </IconButton>
        </DialogActions>
      </Dialog>
    );
  };

  render() {
    const type = this.state.typeLoginSelected;
    const agent = this.state.agentSelected;
    return (
      <div>
        <div className="page-header">
          <ButtonUI
            variant="contained"
            size="small"
            style={{
              backgroundColor: "#000",
            }}
            startIcon={<ArrowBackIos />}
            onClick={() => this.props.history.push("/panel/user")}
          >
            <Typography
              variant="button"
              style={{
                fontSize: 12,
                color: "#fff",
                textTransform: "capitalize",
                marginLeft: -10,
              }}
            >
              Back
            </Typography>
          </ButtonUI>{" "}
          <Typography
            component="span"
            variant="h2"
            style={{
              fontSize: 16,
              color: "#000",
              fontWeight: "bold",
              textTransform: "capitalize",
              float: "right",
            }}
          >
            Edit User
          </Typography>
          <span className="dash">&nbsp;&nbsp;</span>
        </div>
        <div className="box-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item lg={2} md={3} sm={3} xs={12}>
                <Typography
                  component="span"
                  variant="subtitle1"
                  style={{
                    // fontSize: 16,
                    float: "left",
                    marginTop: 6,
                    textTransform: "capitalize",
                  }}
                >
                  {this.language.fieldphone}
                </Typography>
              </Grid>
              <Grid item lg={10} md={9} sm={9} xs={12}>
                <Input
                  autoComplete="off"
                  type="text"
                  name="phoneno"
                  id="phoneno"
                  placeholder="08xxxxxxxxxx"
                  value={this.state.phoneno}
                  // onChange={(event) =>
                  //   this.setState({ phoneno: event.target.value })
                  // }
                />
              </Grid>

              <Grid item lg={2} md={3} sm={3} xs={12}>
                <Typography
                  for="name"
                  component="span"
                  variant="subtitle1"
                  style={{
                    // fontSize: 16,
                    float: "left",
                    marginTop: 6,
                    textTransform: "capitalize",
                  }}
                >
                  {this.language.fieldname}
                </Typography>
              </Grid>
              <Grid item lg={10} md={9} sm={9} xs={12}>
                <Input
                  autoComplete="off"
                  type="text"
                  name="name"
                  id="name"
                  value={this.state.name}
                  placeholder={this.language.fieldname}
                  onChange={(event) =>
                    this.setState({ name: event.target.value })
                  }
                />
              </Grid>

              <Grid item lg={2} md={3} sm={3} xs={12}>
                <Typography
                  component="span"
                  variant="subtitle1"
                  style={{
                    // fontSize: 16,
                    float: "left",
                    marginTop: 6,
                    textTransform: "capitalize",
                  }}
                >
                  {this.language.fieldtype}
                </Typography>
              </Grid>
              <Grid item lg={10} md={9} sm={9} xs={12}>
                <Select
                  classNamePrefix="select"
                  placeholder="Select type"
                  value={this.state.typeLoginSelected}
                  onChange={this.handleChangeTypeLogin}
                  options={this.state.typeLoginOption}
                />
              </Grid>

              {type !== null ? (
                type.value === 2 || type.value === 3 ? (
                  <>
                    <Grid item lg={2} md={3} sm={3} xs={12}>
                      <Typography
                        component="span"
                        variant="subtitle1"
                        style={{
                          float: "left",
                          marginTop: 6,
                          textTransform: "capitalize",
                        }}
                      >
                        Agent
                      </Typography>
                    </Grid>
                    <Grid item lg={10} md={9} sm={9} xs={12}>
                      <Select
                        classNamePrefix="select"
                        placeholder="Select agent"
                        value={this.state.agentSelected}
                        onChange={this.handleChangeAgent}
                        options={this.state.dataAgent}
                      />
                    </Grid>
                  </>
                ) : null
              ) : null}

              {type !== null && agent !== null ? (
                type.value === 3 ? (
                  <>
                    <Grid item lg={2} md={3} sm={3} xs={12}>
                      <Typography
                        component="span"
                        variant="subtitle1"
                        style={{
                          float: "left",
                          marginTop: 6,
                          textTransform: "capitalize",
                        }}
                      >
                        Account
                      </Typography>
                    </Grid>
                    <Grid item lg={10} md={9} sm={9} xs={12}>
                      <Select
                        isMulti
                        classNamePrefix="select"
                        className="basic-multi-select"
                        value={this.state.accountSelected}
                        onChange={this.handleChangeAccount}
                        options={this.state.accountOption}
                        isClearable
                      />
                    </Grid>
                  </>
                ) : null
              ) : null}

              {type !== null && agent === null && type.value === 4 ? (
                <>
                  <Grid item lg={2} md={3} sm={3} xs={12}>
                    <Typography
                      component="span"
                      variant="subtitle1"
                      style={{
                        float: "left",
                        marginTop: 6,
                        textTransform: "capitalize",
                      }}
                    >
                      Account
                    </Typography>
                  </Grid>
                  <Grid item lg={10} md={9} sm={9} xs={12}>
                    <Select
                      isMulti
                      classNamePrefix="select"
                      className="basic-multi-select"
                      value={this.state.accountSelected}
                      onChange={this.handleChangeAccount}
                      options={this.state.accountOption}
                      isClearable
                      formatOptionLabel={(option, { context }) => (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <span style={{ marginRight: 6 }}>
                            {option.status === "active" ? "🟢" : "🔴"}
                          </span>
                          <span>
                            {option.label}
                            {option.status === "archived" && (
                              <em
                                style={{
                                  marginLeft: 4,
                                  color: "#888",
                                  fontStyle: "normal",
                                }}
                              >
                                (archived)
                              </em>
                            )}
                          </span>
                        </div>
                      )}
                      styles={{
                        option: (base, state) => ({
                          ...base,
                          color:
                            state.data.status === "archived"
                              ? "#999"
                              : base.color,
                          fontStyle:
                            state.data.status === "archived"
                              ? "italic"
                              : "normal",
                        }),
                        multiValue: (base, state) => ({
                          ...base,
                          backgroundColor:
                            state.data.status === "archived"
                              ? "#f0f0f0"
                              : "#e6ffed",
                        }),
                        multiValueLabel: (base, state) => ({
                          ...base,
                          color:
                            state.data.status === "archived"
                              ? "#555"
                              : base.color,
                        }),
                      }}
                    />
                  </Grid>
                </>
              ) : null}

              <Grid item lg={2} md={3} sm={3} xs={12}>
                <Typography
                  for="name"
                  component="span"
                  variant="subtitle1"
                  style={{
                    // fontSize: 16,
                    float: "left",
                    marginTop: 6,
                    textTransform: "capitalize",
                  }}
                >
                  {this.language.fieldemail}
                </Typography>
              </Grid>
              <Grid item lg={10} md={9} sm={9} xs={12}>
                <Input
                  autoComplete="off"
                  type="email"
                  name="email"
                  id="email"
                  value={this.state.email}
                  placeholder={this.language.fieldemail}
                  onChange={(event) =>
                    this.setState({ email: event.target.value })
                  }
                />
              </Grid>

              <Grid item lg={2} md={3} sm={3} xs={12}>
                <Typography
                  for="name"
                  component="span"
                  variant="subtitle1"
                  style={{
                    // fontSize: 16,
                    float: "left",
                    marginTop: 6,
                    textTransform: "capitalize",
                  }}
                >
                  {this.language.fieldsuspend}
                </Typography>
              </Grid>
              <Grid item lg={10} md={9} sm={9} xs={12}>
                <SelectMultiColumn
                  width={"100%"}
                  value={this.state.issuspend}
                  valueColumn={"issuspendId"}
                  showColumn={"issuspendName"}
                  columns={["issuspendName"]}
                  data={this.state.suspendShow}
                  onChange={this.suspendHandleChange}
                />
              </Grid>

              {type !== null ? (
                type.value !== 1 ? (
                  <>
                    <Grid item xs={12}>
                      <Divider style={{ margin: "20px 0" }} />
                    </Grid>
                    <Grid item lg={2} md={3} sm={3} xs={12}>
                      <Typography
                        component="span"
                        variant="subtitle1"
                        style={{
                          float: "left",
                          marginTop: 6,
                          textTransform: "capitalize",
                        }}
                      >
                        Access Rights
                      </Typography>
                    </Grid>
                    <Grid item lg={10} md={9} sm={9} xs={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.fullAccess}
                            onChange={this.handleChangeAccessRights}
                            name="fullAccess"
                            color="primary"
                          />
                        }
                        label="Full Access"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.addAccount}
                            onChange={this.handleChangeAccessRights}
                            name="addAccount"
                            color="primary"
                            disabled={this.state.fullAccess}
                          />
                        }
                        label="Add Account"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.changeLot}
                            onChange={this.handleChangeAccessRights}
                            name="changeLot"
                            color="primary"
                            disabled={this.state.fullAccess}
                          />
                        }
                        label="Change Lot"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.pause}
                            onChange={this.handleChangeAccessRights}
                            name="pause"
                            color="primary"
                            disabled={this.state.fullAccess}
                          />
                        }
                        label="Pause"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.suspend}
                            onChange={this.handleChangeAccessRights}
                            name="suspend"
                            color="primary"
                            disabled={this.state.fullAccess}
                          />
                        }
                        label="Suspend"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.active}
                            onChange={this.handleChangeAccessRights}
                            name="active"
                            color="primary"
                            disabled={this.state.fullAccess}
                          />
                        }
                        label="Active"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.addBatch}
                            onChange={this.handleChangeAccessRights}
                            name="addBatch"
                            color="primary"
                            disabled={this.state.fullAccess}
                          />
                        }
                        label="Add Batch (Shoot Arena)"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.setSL}
                            onChange={this.handleChangeAccessRights}
                            name="setSL"
                            color="primary"
                            disabled={this.state.fullAccess}
                          />
                        }
                        label="Set Stop Loss"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.setTP}
                            onChange={this.handleChangeAccessRights}
                            name="setTP"
                            color="primary"
                            disabled={this.state.fullAccess}
                          />
                        }
                        label="Set Take Profit"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.standby}
                            onChange={this.handleChangeAccessRights}
                            name="standby"
                            color="primary"
                            disabled={this.state.fullAccess}
                          />
                        }
                        label="Standby"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.sw}
                            onChange={this.handleChangeAccessRights}
                            name="sw"
                            color="primary"
                            disabled={this.state.fullAccess}
                          />
                        }
                        label="SW"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Divider style={{ margin: "12px 0" }} />
                    </Grid>
                    <Grid item lg={2} md={3} sm={3} xs={12}>
                      <Typography
                        component="span"
                        variant="subtitle1"
                        style={{
                          float: "left",
                          marginTop: 6,
                          textTransform: "capitalize",
                        }}
                      >
                        Pair Type Access
                      </Typography>
                    </Grid>
                    <Grid item lg={10} md={9} sm={9} xs={12}>
                      <Select
                        isMulti
                        classNamePrefix="select"
                        placeholder="Select pair type..."
                        value={this.state.pair_type_selected}
                        onChange={this.handleChangePairType}
                        options={this.state.pair_type_option}
                        isClearable
                        formatOptionLabel={(option) => (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <span style={{ fontWeight: 600 }}>
                              {option.label}
                            </span>
                          </div>
                        )}
                        styles={{
                          multiValue: (base) => ({
                            ...base,
                            backgroundColor: "#e6f0ff",
                          }),
                          multiValueLabel: (base) => ({
                            ...base,
                            fontWeight: 600,
                          }),
                        }}
                      />
                    </Grid>
                  </>
                ) : null
              ) : null}
            </Grid>
          </Box>
          <br></br>
          <div className="form-button-container">
            <br></br>
            <ButtonUI
              variant="contained"
              size="medium"
              style={{
                backgroundColor: "#d0021b",
              }}
              startIcon={<Cancel />}
              onClick={() => this.props.history.push("/panel/user")}
            >
              <Typography
                variant="button"
                style={{
                  fontSize: 12,
                  color: "#fff",
                  textTransform: "capitalize",
                  marginLeft: -6,
                }}
              >
                Cancel
              </Typography>
            </ButtonUI>{" "}
            &nbsp;&nbsp;
            <ButtonUI
              variant="contained"
              size="medium"
              style={{
                backgroundColor: "#004dcf",
              }}
              startIcon={<Save />}
              onClick={() => this.checkData()}
            >
              <Typography
                variant="button"
                style={{
                  fontSize: 12,
                  color: "#fff",
                  textTransform: "capitalize",
                  marginLeft: -6,
                }}
              >
                Save
              </Typography>
            </ButtonUI>{" "}
          </div>
        </div>
        {this.renderValidationAlert()}
        {this.renderAlert()}
      </div>
    );
  }
}
export default EditAdmin;
